export default "__VITE_ASSET__6nvc40v4__"